module.exports = __webpack_public_path__ + "img/IMG_9934-43_P_L_WoodMatted.082f2171.jpg";